import { theme } from "antd";

const custom_theme = {
  algorithm: theme.defaultAlgorithm,
  token: {
    colorPrimary: "#283a98",
    borderRadius: 5,
    wireframe: false,
    fontFamily: "font-primary-regular, sans-serif",
  },
};

export default custom_theme;
